"use client";

import type { JSX } from "react";
import posthog from "posthog-js";

import { LinkButton } from "@repo/ui/link-button";

interface MapDownloadButtonProps {
  href: string;
  mapTitle: string;
}

export function MapDownloadButton({
  href,
  mapTitle,
}: MapDownloadButtonProps): JSX.Element {
  return (
    <LinkButton
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      underline
      size="md"
      className="mt-auto self-start pt-2"
      onClick={() => posthog.capture("map_downloaded", { map_title: mapTitle })}
    >
      Download map
    </LinkButton>
  );
}
